// Source: authenticated routes in App.js. Navigation metadata is never authorization.
const modules = [
  ["home", "Inicio", "dashboard", /^\/$/],
  ["energy_matrix", "Matriz energética", "consumption", /^\/analysis\/energy-matrix$/i],
  ["measurements", "Mediciones", "consumption", /^\/(consumption|perdevice|evolution)$/i],
  ["heatmap", "Mapa de calor", "consumption", /^\/analysis\/heatmap$/i],
  ["passive_load", "Carga pasiva", "consumption", /^\/analysis\/passive-load$/i],
  ["load_demand", "Demanda de potencia", "demand", /^\/(maximetro|analysis\/demandedloaded)$/i],
  ["reactive", "Energía reactiva", "reactive", /^\/analysis\/reactive$/i],
  ["bills_dashboard", "Facturas y consumos", "billing", /^\/ebm\/billsdata$/i],
  ["bill_upload", "Carga de facturas", "billing", /^\/ebm\/uploadbill$/i],
  ["bill_items", "Conceptos de factura", "billing", /^\/(ebm\/itembill|itembill)(\/|$)/i],
  ["reports", "Reportes", "billing", /^\/reports$/i],
  ["ai_reports", "Informes IA", "ai_reports", /^\/insights$/i],
  ["agent_recommendations", "Revisión de recomendaciones IA", "recommendations", /^\/master\/agent-recommendations(\/|$)/i],
  ["recommendations", "Recomendaciones", "recommendations", /^\/recommendations(\/|$)/i],
  ["improvement_projects", "Proyectos de mejora", "projects", /^\/(improvement-projects|projects)(\/|$)/i],
  ["project_monitoring", "Seguimiento de proyectos", "projects", /^\/project-monitoring$/i],
  ["health_safety", "Salud y seguridad", "other", /^\/health-safety$/i],
  ["comfort", "Confort", "other", /^\/confort$/i],
  ["agent_documents", "Documentación del agente", "other", /^\/master\/agent-documents$/i],
  ["devices", "Dispositivos", "other", /^\/(devices|admin\/devices|admin\/energy-meters)(\/|$)/i],
  ["alerts", "Alertas y eventos", "other", /^\/(new-alert|alerts-events|list-alerts|alerts)(\/|$)/i],
  ["admin_users", "Administración de usuarios", "other", /^\/admin\/users(\/|$)/i],
  ["admin_companies", "Administración de empresas", "other", /^\/master\/company(\/|$)/i],
  ["admin_equipment", "Administración de equipos", "other", /^\/master\/equipo(\/|$)/i],
  ["admin_lists", "Administración de listas", "other", /^\/admin\/lists$/i],
  ["suppliers", "Proveedores y suministros", "other", /^\/(ebm\/(suppliers|office)|supplier|supplieroffice)(\/|$)/i],
  ["news", "Novedades", "other", /^\/news$/i],
  ["messages", "Sugerencias", "other", /^\/(admin\/)?suggestions$/i],
  ["profile", "Perfil de usuario", "other", /^\/user\//i],
  ["help", "Ayuda de SIGER", "other", /^\/info(\/|$)/i],
  ["audit", "Auditoría", "other", /^\/(master\/audit|users\/activity)$/i],
  ["costs", "Consumos y costos", "tariff", /^\/costs$/i],
];

export const moduleForPathname = (pathname = "/") => {
  const route = pathname.split(/[?#]/)[0].replace(/\/$/, "") || "/";
  const [module_code, module_title, section] = modules.find((row) => row[3].test(route)) ||
    ["other", "Pantalla de SIGER", "other"];
  const parts = route.split("/").filter(Boolean);
  const last = parts[parts.length - 1];
  const view_code = /^(register|create|uploadbill)$/i.test(last) || parts.includes("create") ? "create" :
    parts.includes("edit") ? "edit" : /^\d+$/.test(last) ? "detail" : "overview";
  return { route, section, module_code, module_title, view_code,
    view_title: { create: "Alta", edit: "Edición", detail: "Detalle", overview: "Vista general" }[view_code] };
};
